






// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import Edit from '@/components/administration/activity/edit/EditSeo.vue'
import { getDefaultAloActivity, AloActivity } from '@/models/alo/AloActivity';
import ReadBaseSeo from '@/components/shared/ReadBaseSeo.vue'
import { toStringDictionary } from '@/utils/groupBy';

@Component({
  name: 'ReadSeo',    
   props: {
    activity:{      
      default:getDefaultAloActivity()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit,ReadBaseSeo}
})
export default class ReadSeo extends Vue {
  private activity!:AloActivity
  private loading!:boolean


  get configuration(){
    return this.$store.myGetters.configuration
  }

  edit() { (this.$refs.edit as Edit).edit(this.activity) }
}
